export default "__VITE_ASSET__DagGXTzp__"